module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.userId !== false) ? _c('mu-card', {
    attrs: {
      "id": "commentForm"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "addCommentTitle",
      "title": 'Add a comment'
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "name": "commentForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addComment.apply(null, arguments)
      }
    }
  }, [_c('mu-text-field', {
    staticClass: "addCommentInput",
    attrs: {
      "hintText": "Add a comment",
      "multiLine": "",
      "fullWidth": "",
      "rows": 3,
      "rowsMax": 6,
      "underlineShow": false
    },
    model: {
      value: (_vm.addCommentModel.message),
      callback: function($$v) {
        _vm.$set(_vm.addCommentModel, "message", $$v)
      },
      expression: "addCommentModel.message"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "addComment",
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "fullWidth": "",
      "type": "button",
      "label": _vm.$t('message.addCommentText'),
      "disabled": _vm.isAddingComment
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addComment.apply(null, arguments)
      }
    }
  })], 1)], 1)])], 1) : _vm._e(), _vm._v(" "), (_vm.userId !== false) ? _c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "flex-start"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "grow": ""
    }
  }, [_c('h2', {
    staticClass: "commentsTitle",
    domProps: {
      "innerHTML": _vm._s(_vm.$sanitize('Comments ' + ' <span>&middot</span> ' + _vm.commentParams.totalComments))
    }
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.comments.length === 0 && !_vm.isCommentsLoading) ? _c('mu-card', {
    staticClass: "noComments"
  }, [_c('mu-card-text', [_vm._v("\n      No comments yet\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.isCommentsLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.comments), function(comment, commentIndex) {
    return (!_vm.isCommentsLoading) ? _c('mu-card', {
      key: 'comment-' + commentIndex,
      staticClass: "comment"
    }, [_c('mu-card-header', {
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('div', {
      staticClass: "mu-card-header-title",
      staticStyle: {
        "padding-right": "40px"
      }
    }, [_c('div', {
      staticClass: "mu-card-title"
    }, [_c('div', {
      staticClass: "titleBlock"
    }, [_c('router-link', {
      staticClass: "name",
      attrs: {
        "to": '/profile/' + comment.user.profile_url
      },
      domProps: {
        "textContent": _vm._s(comment.user.display_name)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dateBadgeWrap"
    }, [_c('div', {
      staticClass: "badges"
    }, [(comment.user.is_admin) ? _c('user-badge', {
      attrs: {
        "mode": "text",
        "type": "support"
      }
    }) : _vm._e(), _vm._v(" "), (comment.user.is_complete) ? _c('user-badge', {
      attrs: {
        "mode": "text",
        "type": "finished-program"
      }
    }) : _vm._e(), _vm._v(" "), (comment.user.is_champion) ? _c('user-badge', {
      attrs: {
        "type": "champion",
        "mode": "text"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('span', {
      staticClass: "date",
      domProps: {
        "textContent": _vm._s(_vm.time(comment.timestamp))
      }
    })])], 1)])]), _vm._v(" "), (!_vm.containsAvatarMed(comment.user.profile_large, 'avatar-med') && comment.user.profile_large != null) ? _c('mu-avatar', {
      attrs: {
        "slot": "avatar",
        "src": comment.user.profile_large
      },
      slot: "avatar"
    }) : _vm._e(), _vm._v(" "), (_vm.containsAvatarMed(comment.user.profile_large, 'avatar-med') || comment.user.profile_large === null) ? _c('mu-avatar', {
      attrs: {
        "slot": "avatar"
      },
      slot: "avatar"
    }, [_vm._v("\n        " + _vm._s(_vm.getInitialsFromName(comment.user.display_name, ' ')) + "\n      ")]) : _vm._e()], 1), _vm._v(" "), _c('mu-card-text', {
      staticStyle: {
        "padding-left": "0px"
      }
    }, [_c('div', {
      staticClass: "desc"
    }, [_c('vue-markdown', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!comment.editcomment),
        expression: "!comment.editcomment"
      }],
      attrs: {
        "source": comment.comment
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (comment.editcomment),
        expression: "comment.editcomment"
      }],
      staticClass: "editable"
    }, [_c('mu-text-field', {
      attrs: {
        "multiLine": "",
        "fullWidth": "",
        "rows": 3,
        "rowsMax": 6
      },
      model: {
        value: (comment.edit_comment),
        callback: function($$v) {
          _vm.$set(comment, "edit_comment", $$v)
        },
        expression: "comment.edit_comment"
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      staticClass: "demo-flat-button",
      attrs: {
        "label": _vm.$t('message.cancelText'),
        "primary": ""
      },
      on: {
        "click": function($event) {
          return _vm.closeReply(0, commentIndex)
        }
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      staticClass: "demo-flat-button",
      attrs: {
        "label": "Save edit",
        "secondary": ""
      },
      on: {
        "click": function($event) {
          return _vm.updateComment(0, comment, commentIndex)
        }
      }
    })], 1)], 1), _vm._v(" "), (comment.report_count > 0 && _vm.isAdmin) ? _c('report', {
      attrs: {
        "type": "LIFE_REPLY",
        "typeId": comment.comment_id
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', [_c('div', {
      staticClass: "buttonsWrap"
    }, [_c('div', [_c('mu-flat-button', {
      staticClass: "likeButton",
      class: {
        'active': comment.likes.liked === true
      },
      on: {
        "click": function($event) {
          return _vm.likeTopComment(comment.comment_id, commentIndex)
        }
      }
    }, [_c('div', {
      staticClass: "likeInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-up"
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "like-label",
      domProps: {
        "textContent": _vm._s(comment.likes.liked ? 'Unlike' : 'Like')
      }
    })], 1)]), _vm._v(" "), ((comment.user.user_id === _vm.$store.state.user.scope.user_id)) ? _c('mu-flat-button', {
      staticClass: "editButton",
      on: {
        "click": function($event) {
          return _vm.editComment(0, commentIndex, null)
        }
      }
    }, [_c('div', {
      staticClass: "editInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "pencil-alt"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1)]) : _vm._e(), _vm._v(" "), ((comment.user.user_id === _vm.$store.state.user.scope.user_id) || (_vm.isAdmin)) ? _c('mu-flat-button', {
      staticClass: "deleteButton",
      on: {
        "click": function($event) {
          return _vm.deleteComment(0, comment.comment_id, commentIndex, null)
        }
      }
    }, [_c('div', {
      staticClass: "deleteInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "trash"
      }
    }), _vm._v(" "), _c('span', [_vm._v("Delete")])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "reportWrap"
    }, [((comment.user.user_id != _vm.$store.state.user.scope.user_id) && (!_vm.isAdmin)) ? _c('mu-flat-button', {
      staticClass: "reportButton",
      attrs: {
        "disabled": comment.reported
      },
      on: {
        "click": function($event) {
          return _vm.openReport('LIFE_REPLY', comment.comment_id)
        }
      }
    }, [_c('div', {
      staticClass: "reportInfo"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "exclamation-triangle"
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "textContent": _vm._s(comment.reported ? 'Reported' : 'Report')
      }
    })], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (comment.total_likes !== 0) ? _c('div', {
      staticClass: "likeCounter"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-up"
      }
    }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(comment.total_likes))]), _vm._v(" people liked this comment")])], 1) : _vm._e(), _vm._v(" "), _c('form', {
      staticClass: "addReply",
      attrs: {
        "name": "commentForm"
      },
      on: {
        "submit": function($event) {
          $event.preventDefault();
          return _vm.addSubComment(comment)
        }
      }
    }, [_c('mu-flexbox', {
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "align": "flex-start",
        "wrap": "nowrap"
      }
    }, [_c('mu-flexbox-item', {
      attrs: {
        "grow": "5"
      }
    }, [_c('h3', {
      staticClass: "replyTo"
    }, [_vm._v("Reply to " + _vm._s(comment.user.display_name) + "'s comment")]), _vm._v(" "), _c('mu-text-field', {
      staticClass: "replyInput",
      attrs: {
        "hintText": "Reply to " + comment.user.display_name + "'s comment.",
        "multiLine": "",
        "fullWidth": "",
        "rows": 3,
        "rowsMax": 6,
        "required": "",
        "underlineShow": false
      },
      model: {
        value: (comment.new_comment),
        callback: function($$v) {
          _vm.$set(comment, "new_comment", $$v)
        },
        expression: "comment.new_comment"
      }
    }), _vm._v(" "), _c('button', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "submit"
      }
    }), _vm._v(" "), _c('mu-flat-button', {
      staticClass: "replyButton",
      attrs: {
        "label": "Add reply",
        "type": "button"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.addSubComment(comment)
        }
      }
    })], 1)], 1)], 1), _vm._v(" "), (comment.replies) ? _c('mu-list', _vm._l((comment.replies), function(sub, subCommentIndex) {
      return _c('div', {
        key: 'subComment-' + subCommentIndex,
        staticClass: "subComment"
      }, [_c('mu-list-item', {
        staticClass: "allowSelection",
        attrs: {
          "disableRipple": ""
        }
      }, [_c('div', {
        staticStyle: {
          "display": "flex",
          "flex-direction": "row",
          "align-items": "center"
        },
        attrs: {
          "slot": "title"
        },
        slot: "title"
      }, [(!_vm.containsAvatarMed(sub.user.profile_large, 'avatar-med') && sub.user.profile_large != null) ? _c('mu-avatar', {
        staticStyle: {
          "margin-right": "18px"
        },
        attrs: {
          "src": sub.user.profile_large
        }
      }) : _vm._e(), _vm._v(" "), (_vm.containsAvatarMed(sub.user.profile_large, 'avatar-med') || sub.user.profile_large === null) ? _c('mu-avatar', {
        staticStyle: {
          "margin-rt": "18px"
        }
      }, [_vm._v("\n              " + _vm._s(_vm.getInitialsFromName(sub.user.display_name, ' ')) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('router-link', {
        staticClass: "name blueTitle",
        attrs: {
          "to": '/profile/' + sub.user.profile_url
        },
        domProps: {
          "textContent": _vm._s(sub.user.display_name)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "dateBadgeWrap"
      }, [_c('div', {
        staticClass: "badges"
      }, [(sub.user.is_admin) ? _c('user-badge', {
        attrs: {
          "mode": "text",
          "type": "support"
        }
      }) : _vm._e(), _vm._v(" "), (sub.user.is_complete) ? _c('user-badge', {
        attrs: {
          "mode": "text",
          "type": "finished-program"
        }
      }) : _vm._e(), _vm._v(" "), (sub.user.is_champion) ? _c('user-badge', {
        attrs: {
          "type": "champion",
          "mode": "text"
        }
      }) : _vm._e()], 1), _vm._v(" "), _c('span', {
        staticClass: "date",
        domProps: {
          "textContent": _vm._s(_vm.time(sub.timestamp))
        }
      })])], 1), _vm._v(" "), _c('div', {
        staticClass: "desc",
        attrs: {
          "slot": "describe"
        },
        slot: "describe"
      }, [_c('vue-markdown', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (!sub.editcomment),
          expression: "!sub.editcomment"
        }],
        attrs: {
          "source": sub.comment
        }
      }), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (sub.editcomment),
          expression: "sub.editcomment"
        }],
        staticClass: "editable"
      }, [_c('mu-text-field', {
        attrs: {
          "multiLine": "",
          "fullWidth": "",
          "rows": 3,
          "rowsMax": 6
        },
        model: {
          value: (sub.edit_comment),
          callback: function($$v) {
            _vm.$set(sub, "edit_comment", $$v)
          },
          expression: "sub.edit_comment"
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        staticClass: "demo-flat-button",
        attrs: {
          "label": _vm.$t('message.cancelText'),
          "primary": ""
        },
        on: {
          "click": function($event) {
            return _vm.closeReply(1, subCommentIndex, commentIndex)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        staticClass: "demo-flat-button",
        attrs: {
          "label": "Save edit",
          "secondary": ""
        },
        on: {
          "click": function($event) {
            return _vm.updateComment(1, sub, subCommentIndex, commentIndex)
          }
        }
      })], 1)], 1), _vm._v(" "), (sub.report_count > 0 && _vm.isAdmin) ? _c('report', {
        attrs: {
          "type": "LIFE_SUBREPLY",
          "typeId": sub.sub_comment_id
        }
      }) : _vm._e(), _vm._v(" "), _c('mu-card-actions', {
        staticClass: "actions"
      }, [_c('div', {
        staticClass: "buttonsWrap"
      }, [_c('div', [_c('mu-flat-button', {
        staticClass: "likeButton",
        class: {
          'active': sub.likes.liked === true
        },
        on: {
          "click": function($event) {
            return _vm.likeSubComment(sub.comment_id, sub.sub_comment_id, commentIndex, subCommentIndex)
          }
        }
      }, [_c('div', {
        staticClass: "likeInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "thumbs-up"
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "like-label",
        domProps: {
          "textContent": _vm._s(sub.likes.liked ? 'Unlike' : 'Like')
        }
      })], 1)]), _vm._v(" "), ((sub.user.user_id === _vm.$store.state.user.scope.user_id)) ? _c('mu-flat-button', {
        staticClass: "editButton",
        nativeOn: {
          "click": function($event) {
            return _vm.editComment(1, subCommentIndex, commentIndex)
          }
        }
      }, [_c('div', {
        staticClass: "editInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "pencil-alt"
        }
      }), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1)]) : _vm._e(), _vm._v(" "), ((sub.user.user_id === _vm.$store.state.user.scope.user_id) || (_vm.isAdmin)) ? _c('mu-flat-button', {
        staticClass: "deleteButton",
        nativeOn: {
          "click": function($event) {
            return _vm.deleteComment(1, sub.sub_comment_id, subCommentIndex, commentIndex)
          }
        }
      }, [_c('div', {
        staticClass: "deleteInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "trash"
        }
      }), _vm._v(" "), _c('span', [_vm._v("Delete")])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
        staticClass: "reportWrap"
      }, [((sub.user.user_id != _vm.$store.state.user.scope.user_id) && (!_vm.isAdmin)) ? _c('mu-flat-button', {
        staticClass: "reportButton",
        attrs: {
          "disabled": sub.reported
        },
        on: {
          "click": function($event) {
            return _vm.openReport('LIFE_SUBREPLY', sub.sub_comment_id)
          }
        }
      }, [_c('div', {
        staticClass: "reportInfo"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "exclamation-triangle"
        }
      }), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(sub.reported ? 'Reported' : 'Report')
        }
      })], 1)]) : _vm._e()], 1)])]), _vm._v(" "), (sub.total_likes !== 0) ? _c('div', {
        staticClass: "likeCounter"
      }, [_c('font-awesome-icon', {
        attrs: {
          "icon": "thumbs-up"
        }
      }), _vm._v(" "), _c('span', [_c('strong', [_vm._v(_vm._s(sub.total_likes))]), _vm._v(" people liked this comment")])], 1) : _vm._e()], 1)], 1)
    }), 0) : _vm._e()], 1) : _vm._e()
  }), _vm._v(" "), _c('mu-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCommentsComplete || _vm.userId !== false),
      expression: "!isCommentsComplete || userId !== false"
    }],
    staticClass: "load-more alignCenter"
  }, [(_vm.commentParams.totalComments > _vm.commentParams.page_size) ? _c('mu-raised-button', {
    attrs: {
      "label": (_vm.isCommentsLoading) ? _vm.$t('message.loadingText') : _vm.$t('message.loadCommentsText'),
      "disabled": _vm.isCommentsComplete || _vm.isCommentsLoading,
      "secondary": ""
    },
    on: {
      "click": function($event) {
        return _vm.loadPostComments(_vm.postId)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.activeReport.type && _vm.activeReport.type_id) ? _c('report-modal', {
    attrs: {
      "open": _vm.activeReport.open,
      "type": _vm.activeReport.type,
      "type_id": _vm.activeReport.type_id
    },
    on: {
      "onClose": function($event) {
        _vm.activeReport.open = false
      },
      "onComplete": function($event) {
        return _vm.setReported(_vm.activeReport)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30021263","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LifeStyle/LifeComments/LifeComments.vue
// module id = 3663
// module chunks = 1